import React, { useState } from 'react';

const CompanyDetail = () => {
  const [activeTab, setActiveTab] = useState('branches');

  return (
    <div>
      <h2>Company Detail</h2>
      <div className="tabs">
        <button onClick={() => setActiveTab('branches')} className={activeTab === 'branches' ? 'active' : ''}>Branches</button>
        <button onClick={() => setActiveTab('product')} className={activeTab === 'product' ? 'active' : ''}>Product</button>
        <button onClick={() => setActiveTab('offer')} className={activeTab === 'offer' ? 'active' : ''}>Offer</button>
      </div>
      <div className="tab-content">
        {activeTab === 'branches' && (
          <div>
            <h3>Branches</h3>
            {/* Branches management UI here */}
          </div>
        )}
        {activeTab === 'product' && (
          <div>
            <h3>Product</h3>
            {/* Product management UI here */}
          </div>
        )}
        {activeTab === 'offer' && (
          <div>
            <h3>Offer</h3>
            {/* Offer management UI here */}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyDetail;
